import { Component, HostListener, OnInit } from '@angular/core';
import { ResultStatus } from '@app/core/models/result-status';
import { HomeService } from '@app/core/services/home.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as _ from "lodash";
import { HelperService } from '@app/core/services/helper.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-what-is-new',
  templateUrl: './what-is-new.component.html',
  styleUrls: ['./what-is-new.component.scss']
})
export class WhatIsNewComponent implements OnInit {
  framelist = [];
  currentFrame = {};
  currentIndex = 0;
  currentFootNote;
  isForAll = false;
  isDataLoaded = false;
  constructor(
    private homeService: HomeService,
    public modalRef: BsModalRef,
    public helperService: HelperService,
    public modalService: BsModalService,
    public toasterService: ToastrService
  ) {
    if (this.modalService.config.initialState["isForAll"]) {
      this.isForAll = this.modalService.config.initialState["isForAll"];
    }
  }

  ngOnInit() {
    this.getSystemWhatIsNewFeatureList();
  }

  getSystemWhatIsNewFeatureList() {
    this.homeService.getSystemWhatIsNewFeatureList(this.isForAll).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.isDataLoaded = true;
        if (this.helperService.isUndefinedOrNullOrEmpty(result.Data)) {
          this.framelist = [];
        } else {
          this.framelist = result.Data;
          this.currentFrame = this.framelist[this.currentIndex];
        }
      } else {
        this.modalRef.hide();
      }
    });
  }

  skip(id) {
    if (!this.helperService.isUndefinedOrNullOrEmpty(id)) {
      this.homeService.MarkAsLaterFeaturePage(id).subscribe(() => {
        this.modalRef.hide();
      });
    } else {
      this.modalRef.hide();
    }
  }

  next(id) {
    if (!this.helperService.isUndefinedOrNullOrEmpty(id)) {
      this.homeService.MarkCompletedFeaturePage(id).subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          this.setNextFrame();
        } else {
          this.modalRef.hide();
        }
      });
    } else {
      this.modalRef.hide();
    }
  }

  setNextFrame() {
    if (this.currentIndex < (this.framelist.length - 1)) {
      this.currentIndex++;
      this.currentFrame = this.framelist[this.currentIndex];
    } else {
      this.modalRef.hide();
    }
  }

  handleCarouselEvents(event) {
    this.currentIndex = event;
    this.currentFrame = this.framelist[event];
  }
}
